import { useContext } from 'react';
import clsx from 'clsx';

import WorkOrderAssetView from '@atom/components/common/workOrderDetail/workOrderAssetView/WorkOrderAssetView';
import WorkOrderContext from '@atom/components/workOrderDetail/WorkOrderContext';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import TaskDetailView from './taskDetailView/TaskDetailView';
import TaskList from './TaskList';

import classes from './workOrderTasks.module.css';

const WorkOrderTasks = () => {
  const {
    workOrderDetail,
    task,
    activeWorkOrderAsset,
    setActiveWorkOrderAsset,
    assetTreeViewState,
    setAssetTreeViewState,
    refetch,
  } = useContext(WorkOrderContext);

  const isTaskView = isNilOrEmpty(activeWorkOrderAsset);
  const displayTaskDetail = !isNilOrEmpty(task);

  return (
    <div className={classes.tasksContainer}>
      {isTaskView ? (
        <>
          <div className={clsx(classes.pane, classes.left)}>
            <TaskList />
          </div>
          <div className={clsx(classes.pane, classes.right)}>
            {displayTaskDetail && <TaskDetailView />}
          </div>
        </>
      ) : (
        <WorkOrderAssetView
          key={activeWorkOrderAsset}
          workOrderDetail={workOrderDetail}
          rootAssetId={activeWorkOrderAsset}
          setActiveWorkOrderAsset={setActiveWorkOrderAsset}
          refetch={refetch}
          taskId={task.id}
          viewState={assetTreeViewState[activeWorkOrderAsset]}
          onViewStateChange={setAssetTreeViewState}
        />
      )}
    </div>
  );
};

export default WorkOrderTasks;
